<template>
	<div :class="[
		'popup-lang',
		{ 'active': this.isActive }
	]">

		<div :class="[
			'lang-dropdown-container',
			{ 'active': this.isActive }
		]">
			<div class="lang-dropdown-bg" v-on:click="toggleVisible()"></div>
			<div ref="lang-dropdown-content" :class="['lang-dropdown-content']">
				<h2 class="title">
					Change Language
				</h2>
				<ul>
					<li :class="[{'active': this.currentLang === 'en'}]" v-on:click="setLanguage('en')">
						English
					</li>
					<li :class="[{'active': this.currentLang === 'es'}]" v-on:click="setLanguage('es')">
						Spanish
					</li>
					<li :class="[{'active': this.currentLang === 'zh'}]" v-on:click="setLanguage('zh')">
						Chinese (Simplified)
					</li>
				</ul>
			</div>
		</div>

		<input type="image" :src="langSvg" v-on:click="toggleVisible()" :class="[
			'popup-button', 
			{ 'visible': this.iconVisible }
		]">
	</div>
</template>

<script>
	import { gsap } from 'gsap';

	export default {
		name: "LanguageSelect",
		data: function() {
			return {
				sharedStore: window.store,
				langSvg: require('../assets/ui/lang-icon.svg'),
				timeline: new gsap.timeline(),
				isActive: false,
				iconVisible: true,
				contentActive: false,
				currentLang: "en"
			}
		},
		mounted: function() {
			// this.processPopupData(this.sharedStore.state.popupData);
		},
		computed: {

		},
		watch: {
			"sharedStore.state.languageCode" : function(e) {
				this.currentLang = e;
			}
		},
		methods: {
			toggleVisible: function() {
				if (this.isActive === true) {
					this.hide();
				} else {
					this.show();
				}
			},
			hide: function() {
				this.isActive = false;
				this.iconVisible = true;

			},
			show: function() {
				this.isActive = true;
				// this.iconVisible = false;
			},
			setLanguage: function(code) {
				let langString = "";
				if (code === "es") {
					langString = "_Spanish";
				} else if (code === "zh") {
					langString = "_Chinese (Simplified)";
				}
				this.sharedStore.setLanguage(code, langString);
			}
		}
	};
</script>

<style scoped lang="scss">
	.popup-lang {
		position: fixed;
		top: 0px;
		right: 0px;
		bottom: 0px;
		left: 0px;
		
		color: #ffffff;
		font-size: 1rem;
		pointer-events: none;

		&.active {
			pointer-events: auto;
		}
	}

	.popup-button {
		position: absolute;
		right: 0;
		top: 0;
		width: 96px;
		height: 70px;
		padding: 12px 20px;
		border: none;
		outline: none;
		cursor: pointer;
		pointer-events: auto;

		transition: 0.2s;
		background-color: rgba(255, 255, 255, 0);
		background-clip: content-box;
		opacity: 0;

		&:active {
			background-color: rgba(255, 255, 255, 0.5);
			transition: 0s;
		}

		&.visible {
			opacity: 1;
		}
	}

	.lang-dropdown-container {
		position: absolute;
		top: 70px;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: hidden;

		.lang-dropdown-bg {
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background: rgba(0, 0, 0, 0);
			transition: 0.4s;
		}

		&.active {
			.lang-dropdown-bg {
				background: rgba(0, 0, 0, 0.5);
			}

			.lang-dropdown-content {
				transform: translateY(0);
			}
		}
	}



	.lang-dropdown-content {
		position: absolute;
		top: 0;
		right: 0;
		width: 100%;
		padding: 15px;
		background: rgb(25, 25, 25);
		transition: 0.2s;
		transform: translateY(-100%);

		@media (min-aspect-ratio: 1/1) {
			width: 50%;
			// transform: translateY(0);
		}

		.title {
			font-weight: bold;
			color: rgb(0, 220, 200);
			padding: 10px 0;
			margin: 0;
		}

		.description {
			text-align: left;
			white-space: pre-wrap;
		}
	}

	ul {
		margin: 0;
		padding: 0;
	}

	li {
		display: flex;
		justify-content: space-between;
		margin: 0 28px;
		padding: 10px 35px;
		border-bottom: 2px solid rgb(33, 33, 33);
		cursor: pointer;
		transition: 0.1s;

		&.active {
			color: #000000;
			background: #ffffff;
		}

		&:last-child {
			border: none;
		}
	}
</style>
